var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataoutput(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 7C13.866 7 17 5.88071 17 4.5C17 3.11929 13.866 2 10 2C6.13401 2 3 3.11929 3 4.5C3 5.88071 6.13401 7 10 7Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 10C3 11.1067 7.11111 12.5 11 12.5C12 12.5 11.9966 12.5 13.0553 12.4168",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 5V15.7059C3 17 6.05911 18.1199 10.4851 18.1199M17 5V8",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-1_14170_513",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.773 22.3201C18.1613 22.6985 18.7804 22.6985 19.1687 22.3201L23.6375 17.9663C24.2801 17.3402 23.8368 16.25 22.9396 16.25L21.0756 16.25L21.0756 12C21.0756 11.4477 20.6279 11 20.0756 11L16.8661 11C16.3138 11 15.8661 11.4477 15.8661 12L15.8661 16.25L14.002 16.25C13.1048 16.25 12.6616 17.3402 13.3042 17.9663L17.773 22.3201Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M19.1687 22.3201L18.1219 21.2458L18.1219 21.2458L19.1687 22.3201ZM17.773 22.3201L18.8198 21.2458L18.8198 21.2458L17.773 22.3201ZM23.6375 17.9663L24.6842 19.0407L24.6842 19.0407L23.6375 17.9663ZM21.0756 16.25L19.5756 16.25L19.5756 17.75L21.0756 17.75L21.0756 16.25ZM20.0756 11L20.0756 9.50003L20.0756 11ZM16.8661 11L16.8661 12.5L16.8661 11ZM15.8661 12L17.3661 12L15.8661 12ZM15.8661 16.25L15.8661 17.75L17.3661 17.75L17.3661 16.25L15.8661 16.25ZM13.3042 17.9663L12.2575 19.0407L12.2575 19.0407L13.3042 17.9663ZM18.1219 21.2458C18.3161 21.0566 18.6256 21.0566 18.8198 21.2458L16.7263 23.3945C17.697 24.3403 19.2447 24.3403 20.2154 23.3945L18.1219 21.2458ZM22.5907 16.8919L18.1219 21.2458L20.2154 23.3945L24.6842 19.0407L22.5907 16.8919ZM22.9396 17.75C22.491 17.75 22.2694 17.2049 22.5907 16.8919L24.6842 19.0407C26.2908 17.4754 25.1826 14.75 22.9396 14.75L22.9396 17.75ZM21.0756 17.75L22.9396 17.75L22.9396 14.75L21.0756 14.75L21.0756 17.75ZM19.5756 12L19.5756 16.25L22.5756 16.25L22.5756 12L19.5756 12ZM20.0756 12.5C19.7995 12.5 19.5756 12.2762 19.5756 12L22.5756 12C22.5756 10.6193 21.4563 9.50003 20.0756 9.50003L20.0756 12.5ZM16.8661 12.5L20.0756 12.5L20.0756 9.50003L16.8661 9.50003L16.8661 12.5ZM17.3661 12C17.3661 12.2762 17.1422 12.5 16.8661 12.5L16.8661 9.50003C15.4853 9.50003 14.3661 10.6193 14.3661 12L17.3661 12ZM17.3661 16.25L17.3661 12L14.3661 12L14.3661 16.25L17.3661 16.25ZM14.002 17.75L15.8661 17.75L15.8661 14.75L14.002 14.75L14.002 17.75ZM14.351 16.8919C14.6723 17.2049 14.4506 17.75 14.002 17.75L14.002 14.75C11.759 14.75 10.6509 17.4754 12.2575 19.0407L14.351 16.8919ZM18.8198 21.2458L14.351 16.8919L12.2575 19.0407L16.7263 23.3945L18.8198 21.2458Z",
    fill: "white",
    mask: "url(#path-4-inside-1_14170_513)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataoutput);
export default __webpack_public_path__ + "static/media/Data output.85349c4d7da8523561803c4ff3f3d0cb.svg";
export { ForwardRef as ReactComponent };